module.exports = __webpack_public_path__ + "img/logo-lavepay.e4af6b64.png";